import { parseTime } from '@/utils/index.js'
import {
  yearsIdFilter,
  STORE_STATE
} from './topUpfilters'
export function timeFilter (value) {
  return parseTime(value, '{y}-{m}-{d} {h}:{i}:{s}')
}
export function timeHoursFilter (value) {
  return parseTime(value, '{y}-{m}-{d} {h}:{i}')
}
export function dateFilter (value) {
  return parseTime(value, '{y}年{m}月')
}
export function timeyearFilter (value) {
  return parseTime(value, '{y}-{m}-{d}')
}
export function yearsFilter (value) {
  return yearsIdFilter[value]
}
export function statusSwitchFilter (value) {
  return STORE_STATE[value]
}
export function moneyFormat (money) {
  debugger
  if (money && money != null) {
    money = String(money)
    var left = money.split('.')[0], right = money.split('.')[1]
    right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00'
    const temp = left.split('').reverse().join('').match(/(\d{1,3})/g)
    return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right
  } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return '0.00'
  } else {
    return ''
  }
}
export function statusFilter (value) {
  const STATUS = {
    '0': '正常',
    '1': '已停用'
  }
  return STATUS[value]
}
